module.exports = __webpack_public_path__ + "img/history-open.bb37edba.svg";